import { notification, Upload, Card, Typography, Space } from 'antd';
import styles from './ProfilePage.module.css';
import { useState } from 'react';
import { EditFilled, LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUser } from '@/shared/store/userSlice';

const { Title, Text } = Typography;

export const ProfilePage = () => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const userInfo = useSelector(state => state.userInfo.userState);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(userInfo.avatar);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      notificationApi.error({
        message: 'Формат файла должен быть PNG или JPEG!',
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notificationApi.error({
        message: 'Изображение должно быть меньше 2MB!',
      });
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, () => {
        setLoading(false);
        setImageUrl(`avatar-${info.file.name.replaceAll(' ', '_')}`);
        dispatch(fetchUser());
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <UserOutlined style={{ fontSize: '24px' }} />}
      <div style={{ marginTop: 8 }}>Сменить фото</div>
    </div>
  );

  const accessToken = JSON.parse(localStorage.userData).token;

  return (
    <div className={styles.profilePage}>
      {contextHolder}
      <Card
        className={styles.profileCard}
        bordered={false}
        style={{
          width: '100%',
          maxWidth: 420,
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Space direction='vertical' align='center' size={16} style={{ width: '100%' }}>
          <Upload
            name='avatar'
            listType='picture-circle'
            className={styles.avatarUploader}
            showUploadList={false}
            action={`api/users/uploadAvatar?userId=${userInfo.userId}`}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            withCredentials={true}
            headers={{
              Authorization: `Bearer ${accessToken}`,
            }}
          >
            {imageUrl ? (
              <div className={styles.photoWrapper}>
                <div style={{ backgroundImage: `url(/uploads/avatars/${imageUrl})` }} className={styles.avatarImage} />
                <div className={styles.editIcon}>
                  <EditFilled />
                </div>
              </div>
            ) : (
              uploadButton
            )}
          </Upload>

          <div style={{ textAlign: 'center' }}>
            <Title level={3} style={{ marginBottom: 0 }}>
              {userInfo.name}
            </Title>
            <Text type='secondary' style={{ fontSize: 16 }}>
              {userInfo.sub_id === 0 ? 'Админ' : 'Пользователь'}
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};
